/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to mark all activity feed entries as read for a risk and context
 * @export
 * @interface MarkAllAsReadCommand
 */
export interface MarkAllAsReadCommand {
    /**
     * Identifier of the insured risk
     * @type {string}
     * @memberof MarkAllAsReadCommand
     */
    risqueAssureId: string;
    /**
     * Reading context (1 = GlobalNotification, 2 = RiskHistory)
     * @type {number}
     * @memberof MarkAllAsReadCommand
     */
    contexte: MarkAllAsReadCommandContexteEnum;
}


/**
 * @export
 */
export const MarkAllAsReadCommandContexteEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type MarkAllAsReadCommandContexteEnum = typeof MarkAllAsReadCommandContexteEnum[keyof typeof MarkAllAsReadCommandContexteEnum];


/**
 * Check if a given object implements the MarkAllAsReadCommand interface.
 */
export function instanceOfMarkAllAsReadCommand(value: object): value is MarkAllAsReadCommand {
    if (!('risqueAssureId' in value) || value['risqueAssureId'] === undefined) return false;
    if (!('contexte' in value) || value['contexte'] === undefined) return false;
    return true;
}

export function MarkAllAsReadCommandFromJSON(json: any): MarkAllAsReadCommand {
    return MarkAllAsReadCommandFromJSONTyped(json, false);
}

export function MarkAllAsReadCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAllAsReadCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'risqueAssureId': json['risqueAssureId'],
        'contexte': json['contexte'],
    };
}

export function MarkAllAsReadCommandToJSON(json: any): MarkAllAsReadCommand {
    return MarkAllAsReadCommandToJSONTyped(json, false);
}

export function MarkAllAsReadCommandToJSONTyped(value?: MarkAllAsReadCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risqueAssureId': value['risqueAssureId'],
        'contexte': value['contexte'],
    };
}

